module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Light.5b1e7c0e.woff";